<template>

  <div id="SchoolFeeReport">
    <div class="container ">

        <div style="background: white">
          <K2Row justify_content="center" class="position-relative p-4">
            <K2Heading type="h5" class-name="mb-0" color="black">SCHOOL FEE REPORT</K2Heading>
          </K2Row>

        </div>

        <div style="background: white" class="position-relative p-4">

          <K2Row class="">
            <K2Row align="center" class="me-2 search-wrap" >
                        <span class="label-control me-2 ">Schools</span>
                          <el-select v-model="ddlSchools" placeholder="Filter By School"
                            class="search-wrap" @change="getAcademiYears();">
                              <el-option
                                      v-for="item in schoolList"
                                      :key="item.SchoolID"
                                      :label="item.SchoolName"
                                      :value="item.SchoolName">
                              </el-option>
                          </el-select>
                      
                          &nbsp; &nbsp; &nbsp;

                          <span class="label-control me-2 ">Academic Year</span>
                          <el-select v-model="ddlAcademicYear" placeholder="Filter By Academic Year"
                            class="search-wrap" >
                              <el-option
                                      v-for="item in semesterList"
                                      :key="item.PK_Semester_ID"
                                      :label="item.SMT_Code"
                                      :value="item.SMT_Code">
                              </el-option>
                          </el-select>

                          &nbsp; &nbsp; &nbsp;

                        <K2Button  :background="uiVariable.color.button2" size="small" @onclick="handleFilter('search');"
                        
                        >
                          {{lang("Search")}}
                        </K2Button>

                        &nbsp;

                        <K2Button  :background="uiVariable.color.secondary" size="small" @onclick="handleClear();" 
                        
                        >
                          {{lang("Clear")}}
                        </K2Button>
                      
            </K2Row>
          </K2Row>

          <K2Row class="text-left">
            <K2Button   size="small" theme="2" @onclick="handleFilter('export')"
              class="text-left"
              >
                {{lang("Export")}}
              </K2Button>
          </K2Row>

          <K2Row class="text-left">
            <K2Button   size="small" theme="2" @onclick="handleFilter('export2')"
              class="text-left"
              >
                {{lang("")}}
              </K2Button>
          </K2Row>

          <div>&nbsp;</div>

          <b-card no-body>
                    
                    <div v-if="fullListByClassNameObj.length>0" class="datatable_group col-lg-12">

                    <div class="datatable-form__submit text-left">
                        <!--<button class="btn btn-success text-left" id="btnClassOverviewDownloadAll" v-on:click="DownloadAllClick(-1, 'All')">Download All</button><br><br>-->
                    </div>

                        <div v-for="(classBatchItem,i) in fullListByClassNameObj">
                            <!--<label>Batch: {{classBatchItem[i].CLS_batch}}</label>-->
                            <data-tables :data="classBatchItem">
                                <el-table-column v-for="studentItem in classBatchItemList" :prop="studentItem.prop"
                                                 :label="studentItem.label" :key="studentItem.prop"
                                                 sortable="custom">
                                </el-table-column>
                            </data-tables>
                            
                        </div>

                    </div>

                    <div class="empty-list_image"
                         v-if="fullListByClassNameObj.length<1">
                        
                        <img src="../../assets/notfound.png"/>
                    </div>

                </b-card>
        
        </div>  
    </div>

  </div>

</template>

<script>
import XLSX from 'xlsx';

import K2Heading from "../../uiComponents/k2Heading/k2Heading";
import K2Row from "../../uiComponents/k2Row/k2Row";

import K2Button from "../../uiComponents/k2Button/k2Button";

import uiVariable from "../../config/uiVariable";
import DataSource from "@/data/datasource";
import { lang } from "@/locale";
import Cookies from "js-cookie";

import Export_CSV from "@/components/Export_CSV";
import { getFormatDate } from "@/helper/utily";


export default {
  name: "SchoolFeeReport",
  components: {  K2Heading, K2Row, K2Button},
  data() {
    return {
      uiVariable: uiVariable,
      selectedTab: 0,
      filterList: [{
        label: "Schools",
        placeholder: "Filter by Schools",
        optionList: []
      }, {
        label: "AcademicYear",
        placeholder: "Filter by AcademiYear",
        selected : [],
      }],
      conUserId:'',
      ddlSchools:'',
      ddlAcademicYear:'',
      schoolList:[],
      semesterList:[],
      newDecryptQuery:[],
      fullListByClassNameObj:[],
      fullListByClassNameObj2:[],
      classBatchItemList:[{
          prop: "FeeSchemeName",
          label: "Fee Scheme Name"
      }, {
          prop: "ItemType",
          label: "Item Type"
      }, {
          prop: "ItemName",
          label: "Item Name"
      }, {
          prop: "AmountwithoutGST",
          label: "Amount without GST"
      }
      ],


                

      detailList: [],
      relationshipDetailList: [],
      selectedSchool: null,
      selectedAcademic: null,
      selectedClass: null,
      dateRange: null,
      dateType: "daterange"



    };
  },
  mounted() {
    this.init();
    this.conUserId = Cookies.get('userIDSession');
  },
  methods:{
    lang,
    async init() {
      await this.getSchools();
      await this.getAcademiYears();

    },
    onFilterChange(value) {
      this.getClass(value);

    },


    handleFilter(type) {

        if (this.ddlSchools == '' || this.ddlSchools == undefined) {
          this.$notify.error({
                                        title: 'Error',
                                        message: 'Please select a school',
                                    });
          return;
        }

        if (this.ddlAcademicYear == '' || this.ddlSchools == undefined) {
          this.$notify.error({
                                        title: 'Error',
                                        message: 'Please select the academic year',
                                    });
          return;
        }

        if (type == 'search')
        {this.loadReport();}
        else if (type == 'export2')
        {
          if (this.newDecryptQuery.length == 0)
            {
              this.$notify.error({
                                          title: 'Error',
                                          message: 'No data to export',
                                      });
              return;
              }
              else
              {
                this.handleExport2();
              }

        }
        else
        {


            //alert(this.fullListByClassNameObj.length);

            if (this.fullListByClassNameObj.length == 0)
            {
              this.$notify.error({
                                          title: 'Error',
                                          message: 'No data to export',
                                      });
              return;
              }
              else
              {
                this.handleExport();
              }
        }

    },

    async getSchools() {

      try {
        const response = await DataSource.shared.getSchoolDropdownListByUser("UTY201300000061");
        if (response) {
            if (response.code === '88') {
                window.location.replace('/');
            } else {
                this.schoolList = response.Table;

            }
        }
        } catch (e) {
          console.log('error getSchools');
        }

    },

    async getAcademiYears() {
      try {
              this.ddlAcademicYear = '';
              const response = await DataSource.shared.getAllAcademicYears(this.ddlSchools);
              if (response) {
                  if (response.code === '88') {
                      window.location.replace('/');
                  } else {
                      this.semesterList = response.Table;
                  }
              }
          } catch (e) {
              console.log('error getAcademiYears');
          }

    },

    async handleClear(){

      this.ddlSchools = undefined;
      this.semesterList = [];
      this.ddlAcademicYear = undefined;
      this.fullListByClassNameObj = [];
      this.fullListByClassNameObj2 = [];
      this.newDecryptQuery = [];
    },

    async loadReport() {
      this.$vs.loading();

      try {
        this.fullListByClassNameObj = [];
        this.fullListByClassNameObj2 = [];
        this.newDecryptQuery = [];

        const resp = await DataSource.shared.GetSchoolFeeReport1(this.ddlSchools, this.ddlAcademicYear);
        //console.log(resp);
        if (resp){

            if(resp.Table){

                this.fullListByClassNameObj.push(resp.Table);


            }
        }
      } catch (e) {
        console.log("error loadReport GetSchoolFeeReport1", e);
      }
      try {
        const resp = await DataSource.shared.GetSchoolFeeReport2(this.ddlSchools, this.ddlAcademicYear);
        //console.log(resp);
        if (resp){
            if(resp.Table){
                this.fullListByClassNameObj2.push(resp.Table);
                //console.log(this.fullListByClassNameObj2);
            }
        }

      } catch (e) {
        console.log("error loadreport GetSchoolFeeReport2", e);
      }

      try {
        const resp = await DataSource.shared.GetSchoolFeeReportManualMovement_Withdrawal(this.ddlSchools, this.ddlAcademicYear);
        //console.log(resp);
        if (resp){
            if(resp.Table){
                this.newDecryptQuery.push(resp.Table);
            }
        }

      } catch (e) {
        console.log("error loadreport GetSchoolFeeReportManualMovement_Withdrawal", e);
      }

      this.$vs.loading.close();

    },

    async handleExport() {


                let exportExcelObject = [];
                let exportExcelObject2 = [];

                var title = this.ddlSchools + '-' + this.ddlAcademicYear

                var currentDateWithFormat = new Date().toJSON().slice(0,10).replace(/-/g,'/');

                var mergedArrNormalWay = [];

                this.fullListByClassNameObj.forEach(o => { o.forEach(so => mergedArrNormalWay.push(so))})

                        mergedArrNormalWay.forEach(n=>{
                            let list={
                                'Fee Scheme Name': n.FeeSchemeName,
                                'Item Type': n.ItemType,
                                'Item Name': n.ItemName,
                                'Amount without GST': n.AmountwithoutGST
                            };
                            exportExcelObject.push(list);
                        });

                var sheet1WS = XLSX.utils.json_to_sheet(exportExcelObject);
                var wb = XLSX.utils.book_new();// make Workbook of Excel
                XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1'); // sheetAName is name of Worksheet
                XLSX.writeFile(wb, 'School Fee Master - '+currentDateWithFormat+ ' - ' +  title + '.xlsx'); // name of the file is 'book.xlsx'



                ////////////////////////////////


                var mergedArrNormalWay2 = [];

                //console.log(this.fullListByClassNameObj2);

                this.fullListByClassNameObj2.forEach(o => { o.forEach(so => mergedArrNormalWay2.push(so))})

                        mergedArrNormalWay2.forEach(n=>{
                            let list2={
                                'Fee Scheme Name': n.FeeSchemeName,
                                'Item Description': n.ItemDescription,
                                'Item Name': n.ItemName,
                                'Item Type': n.ItemType,
                                'Amount without GST': n.AmountwithoutGST,
                                'Category': n.Category,
                                'Time Line': n.TimeLine
                            };
                            exportExcelObject2.push(list2);
                        });

                var sheet1WS2 = XLSX.utils.json_to_sheet(exportExcelObject2);
                var wb2 = XLSX.utils.book_new();// make Workbook of Excel
                XLSX.utils.book_append_sheet(wb2, sheet1WS2, 'sheet1'); // sheetAName is name of Worksheet
                XLSX.writeFile(wb2, 'School Fee Pro Rate - '+currentDateWithFormat+ ' - ' + title +  '.xlsx'); // name of the file is 'book.xlsx'

      /* let finalExportList = [];
      if (this.detailList.length > 0) {
        let add1 ="";
        let add2 ="";
        let add3 ="";
        this.detailList.forEach((m, index) => {
          if (m.address_1){
            add1 = m.address_1 ;
          }
          if (m.address_2){
            add2 = m.address_2 ;
          }
          if (m.address_3){
            add3 = m.address_3 ;
          }
          let tempRow = {
            'reference ': m.reference,
            'user_groups ': m.user_groups,
            'Title': m.Title,
            'first_name': m.first_name,
            'Last_name': m.Last_name,
            'maiden_name': m.maiden_name,
            'Middle_name': m.Middle_name,
            'preferred_first_name': m.preferred_first_name,
            'suffix_1': m.suffix_1,
            'DOB': m.DOB,
            'from': m.from,
            'to': m.to,
            'gender': m.gender,
            'class_of': m.class_of,
            'start_year_group': m.start_year_group,
            'end_year_group': m.end_year_group,
            'house': m.house,
            'default': m.default,
            'email': m.email,
            'addition_email_type': m.addition_email_type,
            'additional_email': m.additional_email,
            'address_type': m.address_type,
            'address_1':add1,
            'address_2':add2,
            'address_3': add3,
            'address_city': m.address_city,
            'address_county_state': m.address_county_state,
            'st_prm_add_country': m.st_prm_add_country,
            'st_prm_add_pstcode': m.st_prm_add_pstcode,
            'phone_number_type': m.phone_number_type,
            'phone_country_code': m.phone_country_code,
            'phone_number': m.phone_number,
            'mobile_country_code': m.mobile_country_code,
            'mobile_number': m.mobile_number,
            'Nationality': m.Nationality,
            'industry_experience': m.industry_experience,
            'note_category': m.note_category,
            'notes': m.notes,
            'deceased': m.deceased,
            'deceased_date': m.deceased_date,
            'education_institution': m.education_institution,
            'education_start_date': m.education_start_date,
            'education_end_date': m.education_end_date,
            'education_subject': m.education_subject,
            'education_level_studied': m.education_level_studied,
            'education_country': m.education_country,
            'education_course': m.education_course,
            'work_employer': m.work_employer,
            'work_industry': m.work_industry,
            'work_start_date': m.work_start_date,
            'work_end_date': m.work_end_date,
            'work_position': m.work_position,
            'individual_letter_salutation': m.individual_letter_salutation,
            'individual_envelope_label_salutation': m.individual_envelope_label_salutation,
            'School_name_custom_value': m.School_name_custom_value,
            'Status_custom_value': m.Status_custom_value,
            'student_no': m.stud_no,

          };

          finalExportList.push(tempRow);
        });
      }


      let finalRelationshipExportList = [];
      if (this.relationshipDetailList.length > 0) {
        this.relationshipDetailList.forEach((m, index) => {

          let tempRow = {
            'party1_id': m.party1_id,
            'party1_reference': m.party1_reference,
            'party2_id': m.party2_id,
            'party2_reference': m.party2_reference,
            'relationship': m.relationship,
          };

          finalRelationshipExportList.push(tempRow);
        });
      }
      if (this.selectedSchool !== ""){

        this.filterList[0].optionList.forEach(e => {
          if (e.id === this.selectedSchool){

          }
          }

        );
      }

      let dateSplit = this.dateRange.split(',')
      let fileName =  "Alumni withdrawals "+dateSplit[0]+" to "+dateSplit[1];
      if (this.selectedSchool !== ""){

        this.filterList[0].optionList.forEach(e => {
            if (e.SchoolID === this.selectedSchool){
              fileName +=" "+ e.SchoolName ;
            }
          }

        );
      }
      let fileNameRelationship =fileName+ " relationship" ;

      Export_CSV.CsvExport(finalExportList, '', '', fileName );
      Export_CSV.CsvExport(finalRelationshipExportList, '', '', fileNameRelationship); */
    },

    async handleExport2() {


      let exportExcelObject = [];

      var title = 'Custom Query';

      var currentDateWithFormat = new Date().toJSON().slice(0,10).replace(/-/g,'/');

      var mergedArrNormalWay = [];

      this.newDecryptQuery.forEach(o => { o.forEach(so => mergedArrNormalWay.push(so))})

              mergedArrNormalWay.forEach(n=>{
                  let list={
                      'ID_Number': n.ID_Number,
                      'Col_1': n.Col_1,
                      'Col_2': n.Col_2,
                      'Col_3': n.Col_3,
                      'Col_4': n.Col_4,
                      'Col_5': n.Col_5,
                      'Col_6': n.Col_6,
                      'Col_7': n.Col_7,
                      'Col_8': n.Col_8,
                      'Col_9': n.Col_9,
                      'Col_10': n.Col_10,
                      'Col_11': n.Col_11,
                      'Col_12': n.Col_12,
                      'Col_13': n.Col_13,
                      'Col_14': n.Col_14,
                      'Col_15': n.Col_15,
                      'Col_16': n.Col_16,
                      'Col_17': n.Col_17,
                      'Col_18': n.Col_18,
                      'Col_19': n.Col_19,
                      'Col_20': n.Col_20,
                      'Col_21': n.Col_21,
                      'Col_22': n.Col_22,
                      'Col_23': n.Col_23,
                      'Col_24': n.Col_24,
                      'Col_25': n.Col_25
                  };
                  exportExcelObject.push(list);
              });


      var sheet1WS = XLSX.utils.json_to_sheet(exportExcelObject);
      var wb = XLSX.utils.book_new();// make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1'); // sheetAName is name of Worksheet
      XLSX.writeFile(wb,  title + '.xlsx'); // name of the file is 'book.xlsx'

    },


  }
};
</script>

<style scoped>

</style>